'use strict';
import 'rxjs/add/operator/combineLatest';
import 'rxjs/add/operator/map';
import fuse from '../../../../_libs/redux-fusion';
import {buildOrganizationLink$} from '../../../../app/navigation/utils';
import {FormsEditHeaderView} from './FormsEditHeaderView';


const StreamedComponent = (state$, dispatch) => (props$) => {
  const breadcrumbPath$ = buildOrganizationLink$(state$)
    .map(link => [link]);

  return props$
    .combineLatest(
      breadcrumbPath$,
      (props, breadcrumbPath) => ({
        ...props,
        breadcrumbPath,
      }));
};

export const FormsEditHeaderContainer = fuse(StreamedComponent)(FormsEditHeaderView);

// Required for legacy angular inter-op
FormsEditHeaderContainer.propTypes = FormsEditHeaderView.propTypes;



// WEBPACK FOOTER //
// ./src/js/forms/components/views/FormsEditHeader/FormsEditHeaderContainer.js